var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{
    'skeleton-rect': _vm.valueLoading,
    'placeholder': _vm.valueLoading && _vm.placeholder,
    'block': _vm.block,
  },style:({
    paddingTop: _vm.paddingTop,
  }),attrs:{"aria-live":"polite","aria-busy":_vm.valueLoading},domProps:{"innerHTML":_vm._s(_vm.value || _vm.placeholder)}})}
var staticRenderFns = []

export { render, staticRenderFns }